import {getUserForId} from './getUserForId'
import {getDisplayNameForUser} from './getDisplayNameForUser'

export function getUserNameForId(userId,repoId,displayCurrentUserName) {	
	return getDisplayNameForUser(getUserForId(userId,repoId),displayCurrentUserName)
}

  